"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
const pino_1 = __importDefault(require("pino"));
const logger = (defaultConfig = {}) => (0, pino_1.default)(Object.assign(Object.assign({}, defaultConfig), { timestamp: false, formatters: {
        level: (label) => {
            return { level: label };
        },
        log: (object) => {
            if (object.err) {
                // backendlogger has an Error-instance, frontendlogger has already serialized it
                const err = object.err instanceof Error ? pino_1.default.stdSerializers.err(object.err) : object.err;
                object.stack_trace = err.stack;
                object.type = err.type;
                object.message = err.message;
                delete object.err;
            }
            return object;
        },
    } }));
exports.logger = logger;
